import React, { useEffect, useState } from "react";
import { validateField } from "../../../service/validation.service";
import FormInputTextComponent from "../../atoms/form-input/form-input-text/form-input-text.component";

const SimpleFormBuilder = ({ inputs, onDataChange, validateCount = 0 }) => {
  const [formInputs, setFormInputs] = useState(inputs);

  const handleChange = ({ index, value }) => {
    let copyFormInputs = [...formInputs];
    copyFormInputs[index] = { ...copyFormInputs[index], value: value };

    const validations = copyFormInputs[index].validations || [];

    copyFormInputs[index] = validateField({
      validations,
      formInput: copyFormInputs[index],
      touchCheck: false,
    });

    setFormInputs(copyFormInputs);
  };

  useEffect(() => {
    if (onDataChange) onDataChange(formInputs);
  }, [formInputs]);

  useEffect(() => {
    if (validateCount > 0) {
      let copyFormInputs = [...formInputs];
      for (let i = 0; i < copyFormInputs.length; i++) {
        const validations = copyFormInputs[i].validations || [];

        copyFormInputs[i] = validateField({
          validations,
          formInput: copyFormInputs[i],
          touchCheck: false,
        });
      }

      setFormInputs(copyFormInputs);
    }
  }, [validateCount]);

  return (
    <div className="simple-form-builder">
      <div className="row">
        {formInputs.map((input, index) => (
          <div key={index} className="col-md-6 mb-3">
            {input.type === "TEXT" && (
              <FormInputTextComponent
                id={input.id}
                name={input.name}
                label={input.label}
                placeholder={input.placeholder}
                value={input.value}
                error={input.error}
                isVertical={true}
                isDisabled={input?.isDisabled || false}
                onChange={(value) =>
                  handleChange({ index, name: input.name, value })
                }
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimpleFormBuilder;
